/**
 * @generated SignedSource<<5f34e0f71110445641e6c84b4ad0186c>>
 * @relayHash d7a05494ef00dde9e7cd75e0034a179d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d7a05494ef00dde9e7cd75e0034a179d

import { ConcreteRequest } from 'relay-runtime';
export type useIsTelematikInfrastructureSigningEnabledQuery$variables = Record<PropertyKey, never>;
export type useIsTelematikInfrastructureSigningEnabledQuery$data = {
  readonly de_isTelematikInfrastructureSigningEnabled: boolean;
};
export type useIsTelematikInfrastructureSigningEnabledQuery = {
  response: useIsTelematikInfrastructureSigningEnabledQuery$data;
  variables: useIsTelematikInfrastructureSigningEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "de_isTelematikInfrastructureSigningEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useIsTelematikInfrastructureSigningEnabledQuery",
    "selections": (v0/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useIsTelematikInfrastructureSigningEnabledQuery",
    "selections": (v0/*:: as any*/)
  },
  "params": {
    "id": "d7a05494ef00dde9e7cd75e0034a179d",
    "metadata": {},
    "name": "useIsTelematikInfrastructureSigningEnabledQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1e0e6de543df16308041a816765e4e22";

export default node;
